import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/admin/journeys/:id/archive
//
// Replaces /app/admin/journeys/_actions.ts::archiveJourneyAction. Pessimistic
// — archive is a state-machine transition; legacy parity. Archived journeys
// remain visible to already-assigned partners (RLS predicates allow viewing
// archived rows if assigned), so bucket-12 portal task lists for those
// partners still need a refresh.
export function useArchiveJourney() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, string>({
    mutationFn: (id) =>
      apiFetch<{ ok: true }>(`/admin/journeys/${id}/archive`, {
        method: "POST",
      }),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.journeys.list() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.journeys.detail(id),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.portal.journeys.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.portal.tasks.all });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to archive journey");
    },
  });
}
